import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, noop, Observable, tap } from 'rxjs';
import { environment } from 'projects/shared/environments/environment';
import { MobileToasterService } from 'projects/shared/components/mobile-toaster/services/mobile-toaster.service';
import { BrowserService } from 'projects/shared/services/browser.service';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class IpService {
  ip$ = new BehaviorSubject<string>(null!)
  constructor(
    private http: HttpClient,
    private _mobileToaster: MobileToasterService,
    private _browserService: BrowserService,
    private _messageService: MessageService
  ) {
    this.catchUserIp();
  }
  catchUserIp() {
    // this.getIP().then((ip: any) => {
    //   console.log('ip: ', ip);
    //   this.ip$.next(ip)
    // });
  }

  async getIP() {
    // return new Promise((resolve) => {
    //   const generateMockIP = () => {
    //     return `192.168.${Math.floor(Math.random() * 256)}.${Math.floor(Math.random() * 256)}`;
    //   };

    //   setTimeout(() => {
    //     resolve(generateMockIP());
    //   }, 500);
    // });
  }

}